import type { CSSProperties, ReactNode } from 'react';

// Sottolineatura a tratto di penna sotto una parola del titolo.
export function PenUnderline({
  children,
  animate = true,
}: {
  children: ReactNode;
  animate?: boolean;
}) {
  return (
    <span className="relative inline-block whitespace-nowrap font-display">
      {children}
      <svg
        viewBox="0 0 220 16"
        preserveAspectRatio="none"
        className="absolute -bottom-2.5 left-0 h-4 w-full overflow-visible text-orange"
        aria-hidden
      >
        <path
          d="M5 10 C 45 3, 90 13, 130 7 S 200 5, 215 9"
          fill="none"
          stroke="currentColor"
          strokeWidth={4}
          strokeLinecap="round"
          className={animate ? 'public-draw' : undefined}
          style={animate ? ({ '--draw-length': '240' } as CSSProperties) : undefined}
        />
      </svg>
    </span>
  );
}
